'use strict';

var app = require('angular').module('app');

app.factory('customTranslateErrorHandler', require('./customTranslateErrorHandler'));
app.factory('rssFeed', require('./rssFeed'));
app.factory('platform', require('./platform'));